/*
 * @Author: your name
 * @Date: 2021-12-01 13:18:43
 * @LastEditTime: 2021-12-15 16:16:39
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\finished-project\finished-project.routing.ts
 */
import { RouterView } from "vue-router";
import { AcceptanceRouting } from "@/views/finished-project/acceptance/acceptance.routing";
import { ApprovalProfitsRouting } from "@/views/finished-project/approval-profits/approvalProfits.routing";
import { FinalAccountsRouting } from "@/views/finished-project/final-accounts/finalAccounts.routing";


export const FinishedProjectManageRouting = {
  path: "/finished-project",
  name: "finished-project",
  redirect: "/acceptance/list",
  component: RouterView,
  meta: { title: "竣工管理", icon: "completed" },
  children: [
    ...AcceptanceRouting,
    ...ApprovalProfitsRouting,
    ...FinalAccountsRouting
  ],
};
